import { useEffect, useState } from 'react';

function createFilterOptions(config = {}) {
  const {
    ignoreAccents = true,
    ignoreCase = true,
    limit,
    matchFrom = 'any',
    stringify,
    trim = false,
  } = config;

  return function (options, { inputValue, getOptionLabel }) {
    let input = trim ? inputValue.trim() : inputValue;

    if (ignoreCase) {
      input = input.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
    }

    const filteredOptions = options.filter((option) => {
      let candidate = (stringify || getOptionLabel)(option);

      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }

      // Custom matching logic can be added here
      return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
    });

    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
  };
}

function stripDiacritics(string) {
  return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

const withFilterPanel = (FilterPanel) => (ownProps) => {
  const { onFilterChange, index, filterModelElement, ifGroupIndex } = ownProps;
  const { type: filterType } = filterModelElement;

  const [isMultiValueEnabled, setIsMultiValueEnabled] = useState(false);

  const blankConditions =
    filterType && (filterType.includes('Blank') || filterType.includes('ternal'));

  const filterOptions = createFilterOptions({
    stringify: (option) => option.name || option.colId || option.value,
  });

  const onRemove = () => {
    onFilterChange(index, null, ifGroupIndex);
  };

  useEffect(() => {
    if (!filterType) return;

    setIsMultiValueEnabled(filterType.includes('Any'));
  }, [filterType]);

  return (
    <FilterPanel
      {...ownProps}
      isMultiValueEnabled={isMultiValueEnabled}
      onRemove={onRemove}
      blankConditions={blankConditions}
      filterOptions={filterOptions}
    />
  );
};

export default withFilterPanel;
